import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SeoService } from '../../seo/seo.service';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'app-palestra',
  imports: [CommonModule],
  templateUrl: './palestra.html',
  styleUrls: ['./palestra.scss'],
})
export class PalestraComponent implements OnInit {
  constructor(private router: Router, private seo: SeoService) {}

  ngOnInit(): void {
    this.seo.updateTags({
      title: 'Pulizia palestre a Pescara | SAMI Pulizie',
      description:
        'Pulizia e sanificazione professionale per palestre, centri sportivi e SPA a Pescara. Attrezzi, spogliatoi, zone umide e pavimenti. Sopralluogo gratuito.',
      keywords:
        'pulizia palestre Pescara, sanificazione palestre, pulizia centri sportivi, pulizia spogliatoi, pulizia spa, SAMI Pulizie',
      canonicalUrl: '/palestra',

      ogTitle: 'Pulizia palestre a Pescara | SAMI Pulizie',
      ogDescription:
        'Servizio professionale per palestre e centri sportivi: igienizzazione attrezzi, spogliatoi e ambienti umidi.',
      ogImage: '/assets/logo.png',
      ogType: 'website',

      twitterCard: 'summary_large_image',
      twitterTitle: 'Pulizia palestre a Pescara | SAMI Pulizie',
      twitterDescription:
        'Interventi professionali per palestre, centri sportivi e SPA a Pescara. Sopralluogo gratuito.',
      twitterImage: '/assets/logo.png',

      jsonLd: {
        '@context': 'https://schema.org',
        '@type': 'Service',
        name: 'Pulizia palestre',
        description:
          'Pulizie professionali per palestre e centri sportivi: attrezzi, spogliatoi, zone umide e pavimenti.',
        provider: {
          '@type': 'CleaningService',
          name: 'SAMI Pulizie',
          url: 'https://samipulizie.it/',
          logo: 'https://samipulizie.it/assets/logo.png',
        },
        areaServed: { '@type': 'AdministrativeArea', name: 'Pescara' },
        url: 'https://samipulizie.it/palestra',
      },
    });
  }

  navigateToPreventiviSito() {
    this.router.navigateByUrl('/preventivo');
  }
}
